import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { getAction, httpAction } from '@/api/manage';
export default {
  name: 'SelectFaceModal',
  components: {},
  data: function data() {
    return {
      title: 'Ai终端管理删除',
      pageTitle: 'Ai终端人脸',
      queryParam: {},
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'faceId',
        colName: 'face_id',
        title: '人脸id',
        align: 'center'
      }, {
        dataIndex: 'tick',
        colName: 'tick',
        title: '时间',
        align: 'center'
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '姓名',
        align: 'center'
      }, {
        dataIndex: 'sex_dictText',
        colName: 'sex',
        title: '性别',
        align: 'center'
      }, {
        dataIndex: 'type_dictText',
        colName: 'type',
        title: '人脸类别',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'tick',
        order: 'desc'
      },
      selectedRowKeys: [],
      selectionRows: [],
      visible: false,
      toggleSearchStatus: false,
      aiDeviceCode: ''
    };
  },
  created: function created() {},
  methods: {
    loadData: function loadData(arg) {
      var _this = this;

      //
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      params.aiDeviceCode = this.aiDeviceCode;
      getAction('/ai/face/queryFaceByDevice', params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
        }
      });
    },
    show: function show(aiDeviceCode) {
      this.visible = true;
      this.queryParam = {};
      this.dataSource = [];
      this.aiDeviceCode = aiDeviceCode;
      this.loadData();
    },
    getQueryParams: function getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField: function getQueryField() {
      var str = 'id,';

      for (var a = 0; a < this.columns.length; a++) {
        str += ',' + this.columns[a].dataIndex;
      }

      return str;
    },
    onSelectChange: function onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    searchReset: function searchReset() {
      var that = this;
      Object.keys(that.queryParam).forEach(function (key) {
        that.queryParam[key] = '';
      });
      that.loadData(1);
    },
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }

      this.ipagination = pagination;
      this.loadData();
    },
    handleCancel: function handleCancel() {
      this.selectionRows = [];
      this.selectedRowKeys = [];
      this.visible = false;
    },
    onClearSelected: function onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    handleOk: function handleOk() {
      this.handleCancel();
    },
    searchByquery: function searchByquery() {
      this.loadData(1);
    },
    handleToggleSearch: function handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    handleDelete: function handleDelete(params) {
      var that = this;
      var method = 'Delete';
      var list = [];
      params.aiDeviceCode = this.aiDeviceCode;
      list.push(params);
      httpAction('/ai/face/deleteTerminalFace', list, method).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadData();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    batchDel: function batchDel() {
      var _this2 = this;

      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择' + this.pageTitle + '记录！');
        return;
      } else {
        this.selectionRows.forEach(function (e) {
          e.aiDeviceCode = _this2.aiDeviceCode;
        });
        var that = this;
        var method = 'Delete';
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中' + this.pageTitle + '数据?',
          onOk: function onOk() {
            httpAction('/ai/face/deleteTerminalFace', that.selectionRows, method).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    }
  }
};